import LeaderLine from "leader-line-new"
// import PlainDraggable from "./plain-draggable.min.js";
// import PlainDraggable from 'PlainDraggable';
import AnimEvent from "anim-event"

var pathVersion = "straight"
const GROUPSETCATEGORY = "Groupsets"
const groupset = document.querySelector(".groupset-bike-detail")
if (groupset) {

  if (!is_mobile) {
    let type = groupset.dataset.version

    if (type) {
      if (type == "version-2") {
        pathVersion = "arc"
      } else if (type == "version-3") {
        pathVersion = "fluid"
      } else if (type == "version-4") {
        pathVersion = "magnet"
      }
    }

    const option1 = {
      size: 2,
      animation: true,
      showEffectName: false,
      endSocket: "right",
      startSocket: "left",
      startPlug: "behind",
      endPlug: "disc",
      path: pathVersion,
      color: "#019fe3",
    }

    const option2 = {
      animOptions: {
        timing: "ease",
        // showEffectName:  'none',
        // duration: 3000,
      },
    }

    const option3 = {
      animOptions: {
        timing: "ease",
        // showEffectName:  'none',
        // duration: 3000,
      },
    }

    const option4 = {
      animOptions: {
        timing: "ease",
        // showEffectName:  'none',
        // duration: 3000,
      },
      size: 2,
      animation: true,
      showEffectName: false,
      startSocket: "right",
      endSocket: "left",
      endPlug: "behind",
      startPlug: "behind",
      // startPlug: "disc",
      path: pathVersion,
      color: "#019fe3",
    }

    const points = [],
      targets = [],
      destinations = []
    const point = document.querySelectorAll(".item-pointer") //end
    const target = document.querySelectorAll(".pointer-item-bike") //start, end-reverse
    const destination = document.querySelectorAll(".blue-dot-bikes") //start-reverse

      ;[].forEach.call(point, function (elm) {
        points.push(elm)
      })
      ;[].forEach.call(target, function (elm) {
        targets.push(elm)
      })
      ;[].forEach.call(destination, function (elm) {
        destinations.push(elm)
      })

    window.addEventListener("DOMContentLoaded", (event) => {
      $(".groupset-bike-detail").addClass("activated")
    })

    window.addEventListener("load", () => {
      for (var i = 0; i < target.length; ++i) {
        let line = new LeaderLine(LeaderLine.mouseHoverAnchor(target[i], "draw", option2), point[i], option1)
        let revLine = new LeaderLine(LeaderLine.mouseHoverAnchor(destination[i], "draw", option3), target[i], option4)

        window.addEventListener(
          "scroll",
          AnimEvent.add(function () {
            line.position()
            revLine.position()
          }),
          true
        )
      }


    })
  }

  /* Analytics */
  window.addEventListener("load", () => {
    $(".pointer-item-bike, .target-item").on("mouseenter", function () {
      track(GROUPSETCATEGORY, `Tab ${$(this).attr("data-tracker-text")} Selected`);
    });

    $(".pointer-item-bike").on("click", function () {
      trackGroupsetCTAClicked($(this));
    });

    $('.target-item').on('shown.bs.popover', function () {
      track(GROUPSETCATEGORY, `Tab ${$(this).attr("data-tracker-text")} Hotspot Opened`, { hotspotType: "pinpoint" })
    })

    $(document).on("click", ".popover-cover", function () {
      trackGroupsetCTAClicked($(this));
    })

    function trackGroupsetCTAClicked(el) {
      track(GROUPSETCATEGORY, `Tab ${el.attr("data-tracker-text") ? el.attr("data-tracker-text") : el.children(".tracker-text").text()} Clicked`, { targetURL: el.attr("href")});
    }
  });
   /* End Analytics */
}
